import { render } from "./ribbons4.vue?vue&type=template&id=4476c1e2"
import script from "./ribbons4.vue?vue&type=script&lang=js"
export * from "./ribbons4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__